import { EntitlementStatementSimple } from '@dreryk/egabinet-patient-frontend-api';

import { StyledFlex } from '@dreryk/react-components';

import { IdentityDocumentText } from './IdentityDocumentText';
import { RepresentativeIdentityDocument } from './RepresentativeIdentityDocument';

type IdentityDocumentCellProps = Pick<
   EntitlementStatementSimple,
   | 'patientIdentityDocumentType'
   | 'patientIdentityDocumentValue'
   | 'representativeIdentityDocumentType'
   | 'representativeIdentityDocumentValue'
>;

export const IdentityDocumentCell = (props: IdentityDocumentCellProps): JSX.Element => {
   const {
      patientIdentityDocumentType,
      patientIdentityDocumentValue,
      representativeIdentityDocumentType,
      representativeIdentityDocumentValue,
   } = props;

   return (
      <StyledFlex direction={'column'}>
         <IdentityDocumentText
            documentType={patientIdentityDocumentType}
            documentValue={patientIdentityDocumentValue}
         />
         {representativeIdentityDocumentType && representativeIdentityDocumentValue ? (
            <RepresentativeIdentityDocument
               documentType={representativeIdentityDocumentType}
               documentValue={representativeIdentityDocumentValue}
            />
         ) : null}
      </StyledFlex>
   );
};
